export const AccountToast = {
  methods: {
    showLoginToast() {
      this.$toasted.show("로그인이 필요합니다", {
        action: [{
          text: "로그인",
          onClick: (e, toast) => {
            localStorage.setItem("fromPath", this.$route.path)
            this.$router.push('/login')
            toast.goAway(0)
          }
        }]
      })
    },
    showVerifyToast() {
      this.$toasted.show("이메일 인증이 필요합니다", {
        action: [{
          text: "인증",
          onClick: (e, toast) => {
            localStorage.setItem("fromPath", this.$route.path)
            this.$router.push('/verify-email')
            toast.goAway(0)
          }
        }]
      })
    },
    showNameToast() {
      this.$toasted.show("닉네임을 결정해주세요", {
        action: [{
          text: "입력",
          onClick: (e, toast) => {
            localStorage.setItem("fromPath", this.$route.path)
            this.$router.push({
              name: 'SignUp',
              params: {
                  isSNS: true
              }
            })
            toast.goAway(0)
          }
        }]
      })
    },
  }
}